// TODO: Only `customElement.define` can extend <texterae>, and trap ".value"
// setting and event, because Lit-Element not supports the native HTMLElment
// extend and `new Proxy` breaks all DOM apis.
/**
 * wrap textarea for auto resize
 * @experimental this method will have breaking changes in future.
 */
export function enhanceTextarea(textarea) {
    textarea.rows = 1;
    const resize = () => {
        // NOTE: `textarea.rows` can't adjust height because of bottom scrollbar
        textarea.style.height = 'auto';
        const { scrollHeight, offsetHeight, clientHeight, scrollWidth, clientWidth, } = textarea;
        const hasHScrollBar = scrollWidth > clientWidth;
        const scrollbarHeight = offsetHeight - clientHeight;
        const height = hasHScrollBar
            ? scrollHeight + scrollbarHeight
            : scrollHeight;
        textarea.style.height = `${height}px`;
    };
    let lastValue = '';
    const triggerChange = () => {
        if (lastValue !== textarea.value) {
            setTimeout(() => {
                if (textarea.parentElement) {
                    textarea.dispatchEvent(new InputEvent('change'));
                }
            });
            lastValue = textarea.value;
        }
    };
    textarea.addEventListener('keyup', (event) => {
        const e = event;
        // change 触发频率太低，增加触发频率
        if ([' ', 'Enter', 'Delete', 'Backspace', 'Escape', 'Copy', 'Paste'].includes(e.key)) {
            triggerChange();
        }
    });
    ['cut', 'paste', 'blur'].forEach((eventName) => {
        textarea.addEventListener(eventName, () => {
            triggerChange();
        });
    });
    ['input', 'change'].forEach((eventName) => {
        textarea.addEventListener(eventName, () => {
            resize();
        });
    });
    setTimeout(() => {
        resize();
    });
    const enhanced = Object.assign(textarea, {
        resize,
    });
    return enhanced;
}
//# sourceMappingURL=textarea.js.map